<template>
  <div>
    <div>
      <CustomLoader></CustomLoader>
    </div>
    <div class="main-container" v-if="loaded">
      <div style="width: 800px;">
        <div :id="'main_' + courseId">
          <div class="row" id="after1">
            <div class="w-100 d-flex justify-content-start">
              <img src="@/assets/images/logo.png" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center my-3">
              <span class="title text-center"
                >Reporte de Actividad por Curso/Sección</span
              >
            </div>
          </div>
          <div class="row w-90">
            <div class="d-flex justify-content-center">
              <table>
                <tbody>
                  <tr>
                    <td class="font-weight-bolder border text-right py-0">
                      Colegio
                    </td>
                    <td colspan="3" class=" border py-0">
                      {{ reportData.courseTeacherDTO.teacher.school.name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder border text-right py-0">
                      Curso / Sección
                    </td>
                    <td colspan="3" class=" border py-0">
                      {{ reportData.courseTeacherDTO.course.name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder border text-right py-0">
                      Periodo informado
                    </td>
                    <td colspan="3" class=" border py-0">
                      1 al 30 de {{ reportPeriod.monthName }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder border text-right py-0">
                      Docente a cargo
                    </td>
                    <td colspan="3" class=" border py-0">
                      {{ reportData.courseTeacherDTO.teacher.firstname }}
                      {{ reportData.courseTeacherDTO.teacher.lastname }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder border text-right py-0">
                      Resultado en Diagnóstico Inicial
                    </td>
                    <td class="text-center border py-0">
                      % Logro Localizar u Obtener Información <br /><b
                        >{{ initialDiagnosticLOC }}%</b
                      >
                    </td>
                    <td class="text-center border py-0">
                      % Logro Integrar e Interpretar <br /><b
                        >{{ initialDiagnosticIN }}%</b
                      >
                    </td>
                    <td class="text-center border py-0">
                      % Logro Reflexionar y Valorar <br /><b
                        >{{ initialDiagnosticREV }}%</b
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Sección 1 -->
          <div
            class="row d-flex flex-column justify-content-center align-items-center mt-2"
          >
            <div class="col-12">
              <span class="subtitle text-black">1. Resultados generales</span>
            </div>
            <div
              v-if="!reportData.generalDTO.exceptionMsg"
              class="d-flex flex-column justify-content-center align-items-center w-100"
            >
              <span class="text-center subtitle text-dark"
                >Total en Comprensión Lectora</span
              >
              <div class="w-100 text-center ">
                <Legend />
              </div>
              <div
                class="w-50 d-flex justify-content-center align-items-center"
              >
                <DoughnutChartContainer
                  id="totalReadingChart"
                  :isReport="true"
                  :key="6"
                  :data="reportData.generalDTO"
                  :padding="15"
                  :legendDisplay="false"
                  :showAmounts="true"
                />
              </div>
            </div>
            <div v-else class="col-auto my-4 text-center mx-auto">
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <div
            v-if="!reportData.generalDTO.exceptionMsg"
            class="row w-100 justify-content-around beforeClass"
            id="after2"
          >
            <div
              class="col-6 d-flex flex-column align-items-center justify-content-center"
            >
              <span class="text-center text-dark">Total en Libros</span>
              <DoughnutChartContainer
                id="totalBooksChart"
                :isReport="true"
                :data="reportData.generalDTO.evaluacionLibros"
                :case="'libros'"
                :legendDisplay="false"
                :padding="10"
                :showLabels="false"
                :showAmounts="true"
              />
            </div>
            <div
              class="col-6 d-flex flex-column align-items-center justify-content-center"
            >
              <span class="text-center text-dark">Total en Desafíos</span>
              <DoughnutChartContainer
                id="totalChallengesChart"
                :isReport="true"
                :data="reportData.generalDTO.desafio"
                :case="'desafios'"
                :legendDisplay="false"
                :padding="10"
                :showLabels="false"
                :showAmounts="true"
              />
            </div>
          </div>
          <span class="html2pdf__page-break"></span>
          <!-- Sección 2 -->
          <div class="row mb-4" id="after1">
            <div class="w-100 d-flex justify-content-start">
              <img src="@/assets/images/logo.png" />
            </div>
          </div>
          <div
            class="row justify-content-start align-center"
            id="detail-by-skill"
          >
            <div class="col-12">
              <span class="subtitle">
                2. Resultados por Habilidad / Capacidad de Comprensión Lectora
              </span>
            </div>
            <div v-if="!reportData.generalDTO.exceptionMsg" class="col-11">
              <div class="card-section">
                <span class="text-barlow-condensed subtitle text-dark">
                  Respuestas en total
                </span>
              </div>
              <div class="card-section">
                <LegendDetailBySkill />
              </div>
              <div
                v-for="(data, i) in stackData"
                :key="i"
                class="card-section text-center"
              >
                <HorizontalStackedBar :isReport="true" :data="data" />
              </div>
            </div>
            <div v-if="!reportData.generalDTO.exceptionMsg" class="col-12">
              <span class="subtitle">
                Estudiantes más descendidos por habilidad / capacidad:
              </span>
            </div>
            <div v-if="!reportData.generalDTO.exceptionMsg" class="col-12 mt-4">
              <Student
                :monthlyReportData="reportData.generalDTO.evaluacionLibros"
                :isReport="true"
              ></Student>
            </div>
            <div
              v-if="reportData.generalDTO.exceptionMsg"
              class="col-auto my-4 text-center mx-auto"
            >
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <span class="html2pdf__page-break"></span>
          <!-- Sección 3 -->
          <div class="row mb-4" id="after1">
            <div class="w-100 d-flex justify-content-start">
              <img src="@/assets/images/logo.png" />
            </div>
          </div>
          <div class="row justify-content-center" id="evolution">
            <div class="col-12">
              <span class="subtitle">
                3. Evolución
              </span>
            </div>
            <div
              v-if="!reportData.evolucionDTO.exceptionMsg"
              class="col-12 mt-3"
            >
              <span class="lead text-center">
                Tu curso / sección tuvo un
                <strong>{{ initialDiagnosticValue }}% de logro</strong>
                diagnóstico inicial. Mientras que durante el mes de
                <strong>{{ reportPeriod.monthName }}</strong> obtuvo un
                <strong>nivel de logro del {{ endOfMonthValue }}%</strong>.
              </span>
            </div>
            <div
              v-if="!reportData.evolucionDTO.exceptionMsg"
              class="col-11 p-0 mt-3"
            >
              <BarLineChartContainer
                id="evolutionChart"
                :isReport="true"
                :hideLegend="true"
                :data="chartData.evolution"
              />
            </div>
            <div
              v-if="reportData.evolucionDTO.exceptionMsg"
              class="col-auto my-4 text-center mx-auto"
            >
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <!-- Sección 4 -->
          <div class="row justify-content-center mt-3">
            <div class="col-12 mb-3">
              <span class="subtitle">4. Plan de Lectura Complementaria</span>
            </div>
            <template v-if="!reportData.readingPlanDTO.exceptionMsg">
              <template
                v-for="(assignment, index) of reportData.readingPlanDTO
                  .monthAssignments"
              >
                <span
                  v-if="index === 1"
                  class="html2pdf__page-break"
                  :key="`${index} pageBreak`"
                ></span>
                <div
                  class="col-4 ml-n3 text-center"
                  :key="`${index} booksOfMonth`"
                >
                  <span class="text-dark my-2 font-weight-bolder"
                    >Asignación: {{ assignment.startingDate }} /
                    {{ assignment.evaluationDate }}</span
                  >
                  <img
                    id="img-cover-for-rendered"
                    class="border"
                    :src="assignment.imageBase64"
                    alt="cover img"
                    v-if="assignment.imageBase64 != 0"
                  />
                  <div
                    v-if="assignment.imageBase64 == 0"
                    class="resport-cover-img d-flex flex-column justify-content-center w-100 mt-5"
                  >
                    <span class="text-center text-small">{{
                      assignment.book.title
                    }}</span>
                  </div>
                </div>
                <div class="col-5 text-center" :key="`${index} comprehension`">
                  <span class="ml-n4 text-dark my-2 font-weight-bolder"
                    >Comprensión Lograda</span
                  >
                  <div class="report-compresion">
                    <DoughnutChartContainer
                      id="comprehensionChart"
                      :isReport="true"
                      :data="assignment.mdReportInfoDTO"
                      :case="'libros'"
                      :legendDisplay="false"
                      :padding="6"
                      :showLabels="false"
                    />
                  </div>
                </div>
                <div class="col-3 text-center" :key="`${index} advance`">
                  <span class="text-dark my-2 font-weight-bolder"
                    >Avance en Lectura</span
                  >
                  <div
                    class="resport-cover-img d-flex flex-column justify-content-center w-100 mt-5"
                  >
                    <span class="display-4 text-center">
                      {{ assignment.porcentajeAvance.toFixed(2) }}%
                    </span>
                    <span class="text-center text-small">
                      de páginas leídas</span
                    >
                  </div>
                </div>
              </template>
              <div class="col-11 border mt-2">
                <div
                  class="d-flex flex-row justify-content-center align-items-center"
                >
                  <span
                    class="text-center text-dark my-2 font-weight-bolder mx-2  text-small"
                    >Libro del Próximo Mes:
                  </span>
                  <span class="text-center text-dark my-2 text-small">
                    {{ bookNextMonthTitle }}
                  </span>
                </div>
              </div>
            </template>
            <div
              v-if="reportData.readingPlanDTO.exceptionMsg"
              class="col-auto my-4 text-center mx-auto"
            >
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <span class="html2pdf__page-break"></span>
          <!-- Sección 5 -->
          <div class="row mb-4" id="after1">
            <div class="w-100 d-flex justify-content-start">
              <img src="@/assets/images/logo.png" />
            </div>
          </div>
          <div class="row justify-content-center d-flex">
            <div class="col-12">
              <span class="subtitle">5. Velocidad Lectora</span>
            </div>
            <div
              v-if="!reportData.readingSpeedDTO.exceptionMsg"
              class="col-11 text-center mt-3"
            >
              <table class="border">
                <tbody class="text-center">
                  <tr>
                    <td class="font-weight-bolder border">
                      Promedio del Curso/Sección Últimos 30 Días
                    </td>
                    <td class="font-weight-bolder border">
                      Velocidad Sugerida
                    </td>
                    <td class="font-weight-bolder border">
                      Promedio del Curso/Sección Periodo Anterior
                    </td>
                  </tr>
                  <tr>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small">{{
                          reportData.readingSpeedDTO.avgCourseLast30days.toFixed(
                            2
                          )
                        }}</span
                        ><span>Palabras por Minuto</span>
                      </div>
                    </td>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small">{{
                          reportData.readingSpeedDTO.suggestedSpeed
                        }}</span
                        ><span>Palabras por Minuto</span>
                      </div>
                    </td>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small">{{
                          reportData.readingSpeedDTO.avgCoursePrevPeriod.toFixed(
                            2
                          )
                        }}</span
                        ><span>Palabras por Minuto</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="col-auto my-4 text-center mx-auto">
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <!-- Sección 6 -->
          <div class="row justify-content-center d-flex mt-5">
            <div class="col-12">
              <span class="subtitle">6. Hábitos y Preferencias</span>
            </div>
            <div
              v-if="!reportData.preferencesDTO.exceptionMsg"
              class="col-11 text-center mt-3"
            >
              <table class="border">
                <tbody class="text-center">
                  <tr>
                    <td class="font-weight-bolder border">
                      % de Estudiantes con Una Sesión Semanal
                    </td>
                    <td class="font-weight-bolder border">
                      % de Estudiantes con Dos Sesión Semanal
                    </td>
                    <td class="font-weight-bolder border">
                      % de Estudiantes con Tres Sesión Semanal
                    </td>
                  </tr>
                  <tr>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small"
                          >{{
                            reportData.preferencesDTO
                              .porcentajeEstudiantes1SesionSemanal
                          }}%</span
                        >
                      </div>
                    </td>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small"
                          >{{
                            reportData.preferencesDTO
                              .porcentajeEstudiantes2SesionSemanal
                          }}%</span
                        >
                      </div>
                    </td>
                    <td class="border">
                      <div class="d-flex flex-column justify-content-center">
                        <span class="font-weight-bolder text-small"
                          >{{
                            reportData.preferencesDTO
                              .porcentajeEstudiantes3SesionSemanal
                          }}%</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="col-auto my-4 text-center mx-auto">
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
          <!-- Sección 7 -->
          <div class="row d-flex mt-5 mb-5">
            <div class="col-12">
              <span class="subtitle">7. Los mejores del Mes</span>
            </div>
            <div
              v-if="!reportData.preferencesDTO.exceptionMsg"
              class="col-12 mt-3"
            >
              <div class="d-flex flex-row justify-content-around">
                <div
                  class="d-flex flex-column justify-content-start align-items-center border border-radius-2 shadow rounded p-2 w-25"
                >
                  <span
                    class="font-weight-bolder text-center text-secondary border-bottom p-2"
                  >
                    Los 3 que mas Leyeron
                  </span>
                  <span
                    class="text-content-card text-center py-1"
                    v-for="(item, index) of reportData.preferencesDTO
                      .estudiantesMasLeyeron"
                    :key="index"
                  >
                    {{ item.user.firstname }} {{ item.user.lastname }}
                  </span>
                </div>
                <div
                  class="d-flex flex-column justify-content-start align-items-center border border-radius-2 shadow rounded p-2 w-25"
                >
                  <span
                    class="font-weight-bolder text-center text-secondary border-bottom p-2"
                  >
                    Los 3 con Mejor Comprensión Lectora
                  </span>
                  <span
                    class="text-content-card text-center py-1"
                    v-for="(item, index) of reportData.preferencesDTO
                      .estudiantesMejorComprension"
                    :key="index"
                  >
                    {{ item.user.firstname }} {{ item.user.lastname }}
                  </span>
                </div>
                <div
                  class="d-flex flex-column justify-content-start align-items-center border border-radius-2 shadow rounded p-2 w-25"
                >
                  <span
                    class="font-weight-bolder text-center text-secondary  border-bottom p-2"
                  >
                    Los 3 que mas Progresaron en los últimos 30 días
                  </span>
                  <span
                    class="text-content-card text-center py-1"
                    v-for="(item, index) of reportData.preferencesDTO
                      .estudiantesMasProgresaron"
                    :key="index"
                  >
                    {{ item.user.firstname }} {{ item.user.lastname }}
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="col-auto my-4 text-center mx-auto">
              <span class="font-weight-bold text-black">
                No hay datos para mostrar
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DoughnutChartContainer from "@/components/generalResults/DoughnutChartContainer";
import Legend from "@/components/generalResults/Legend";
import html2pdf from "html2pdf.js";

// Componentes
import HorizontalStackedBar from "@/components/HorizontalStackedBar";
import LegendDetailBySkill from "@/components/detailBySkill/Legend";
import CustomLoader from "@/components/CustomLoader";
import BarLineChartContainer from "@/components/BarContainer/BarLineChartContainer";
import Student from "@/views/dashboard/analytics/reports/detailBySkill/Students.vue";

// const REPORT_DATA = require("./data.json");

const monthNames = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

export default {
  name: "MonthlyReport",
  props: {
    teacherId: null,
    courseId: null,
    dateFrom: null,
    dateTo: null,
    courseName: null,
  },
  components: {
    DoughnutChartContainer,
    Legend,
    HorizontalStackedBar,
    LegendDetailBySkill,
    BarLineChartContainer,
    Student,
    CustomLoader,
  },
  computed: {
    ...mapState(["dataUrl", "userData"]),
    initialDiagnosticValue() {
      if (this.reportData.evolucionDTO.exceptionMsg) return null;

      return this.reportData.evolucionDTO.report.find(item => item.index === 0)
        .porcentajeCorrectas;
    },
    endOfMonthValue() {
      if (this.reportData.evolucionDTO.exceptionMsg) return null;

      return this.reportData.evolucionDTO.report.find(item => item.index > 0)
        .porcentajeCorrectas;
    },
    month() {
      const dateElements = this.reportData.dateTo.substr(0, 10).split("-");
      return Number.parseInt(dateElements[1]);
    },
    reportPeriod() {
      const dateElements = this.reportData.dateTo.substr(0, 10).split("-");
      const month = Number.parseInt(dateElements[1]);
      const year = Number.parseInt(dateElements[0]);
      return {
        monthName: monthNames[month - 1],
        month,
        year,
      };
    },
    initialDiagnosticLOC() {
      if (this.reportData.generalDTO.exceptionMsg) return null;

      return this.reportData.generalDTO.diagnostico.totalCorrectasLocalizar;
    },
    initialDiagnosticIN() {
      if (this.reportData.generalDTO.exceptionMsg) return null;

      return this.reportData.generalDTO.diagnostico.totalCorrectasIntegrar;
    },
    initialDiagnosticREV() {
      if (this.reportData.generalDTO.exceptionMsg) return null;

      return this.reportData.generalDTO.diagnostico.totalCorrectasReflexionar;
    },
    bookNextMonthTitle() {
      if (this.reportData.readingPlanDTO.exceptionMsg) return null;

      return this.reportData.readingPlanDTO.nextMonthAssingments.length > 0
        ? this.reportData.readingPlanDTO.nextMonthAssingments[0].title
        : "No asignado";
    },
  },
  data() {
    const { primCol } = this.$store.getters;

    return {
      removedFromSelectedCourses: false,
      imageBase64: 0,
      reportDate: null,
      reportData: {},
      loaded: false,
      stackData: [],
      chartData: {
        total: {
          label: "Porcentaje de logro",
          barColor: primCol,
          data: {},
        },
        evolution: {
          label: "% de logro",
          barColor: primCol,
          data: {},
        },
      },
    };
  },
  async created() {
    try {
      let data = null;
      data = await this.axios.get(
        this.dataUrl +
          `/analytics/getReportDataByTeacherAndCourse?teacherId=${this.teacherId}&courseId=${this.courseId}&dateFrom=${this.dateFrom}&dateTo=${this.dateTo}`
      );
      // data = { data: REPORT_DATA };

      this.reportData = data.data.content;

      if (
        this.reportData === "No hay datos de sesiones de lectura para este mes"
      ) {
        //  this.updateShowReport();
        this.addGenerateCourse({ courseId: this.courseId });
        this.$notify({
          title: [`${this.reportData}, ${this.courseName}`],
          type: "danger",
        });
        return;
      }

      if (this.reportData === "No existe diagnostico incial para este curso") {
        // this.updateShowReport();
        this.addGenerateCourse({ courseId: this.courseId });
        this.$notify({
          title: [`${this.reportData} ${this.courseName}`],
          type: "danger",
        });
        return;
      }

      if (!this.reportData.generalDTO.exceptionMsg) this.setDetailBySkillData();
      if (!this.reportData.evolucionDTO.exceptionMsg) this.setEvolutionData();

      try {
        const imagesBase64 = await Promise.all(
          this.reportData.readingPlanDTO.monthAssignments.map(assignment =>
            this.imageWithMetaData(
              assignment.book.id,
              `https://assets.beereaders.com/lbr/image/${assignment.book.resourceDir}/cover_small.jpg`
            )
          )
        );
        this.reportData.readingPlanDTO.monthAssignments.forEach(
          assignment =>
            (assignment.imageBase64 = imagesBase64.find(
              imageWithMetaData =>
                imageWithMetaData.metaData === assignment.book.id
            ).imageBase64)
        );
      } catch (e) {
        console.error("Error al descargar imagen base64", e);
      }

      this.loaded = true;
      setTimeout(() => {
        this.toPDF();
      }, 6000);
    } catch (error) {
      this.addGenerateCourse({ courseId: this.courseId });
      console.error("Error al generar el reporte", error);
      this.$notify({
        title: [
          `No se pudo descargar reporte de curso ${this.courseName}, por falta de datos`,
        ],
        type: "danger",
      });
    }
  },
  methods: {
    ...mapActions([
      "removeCourse",
      "removeCourseFromPending",
      "addGenerateCourse",
    ]),
    validValue(value) {
      return !!value && value !== 0;
    },
    getPercentage(num1, num2) {
      if (!this.validValue(num2)) return 0;
      return (100 * num1) / num2;
    },
    setEvolutionData() {
      for (let item of this.reportData.evolucionDTO.report) {
        let label = item.index
          ? item.dateTo.split(" ")[0]
          : "Diagnóstico inicial";

        this.chartData.evolution.data[label] = item.porcentajeCorrectas;
      }
    },
    setDetailBySkillData() {
      this.stackData = [
        {
          label: "Localizar y obtener información",
          correct: this.reportData.generalDTO.porcentajeCorrectasLocalizar,
          incorrect: this.reportData.generalDTO.porcentajeIncorrectasLocalizar,
          notAnswered: this.reportData.generalDTO
            .porcentajeNoContestadasLocalizar,
        },
        {
          label: "Reflexionar y valorar",
          correct: this.reportData.generalDTO.porcentajeCorrectasReflexionar,
          incorrect: this.reportData.generalDTO
            .porcentajeIncorrectasReflexionar,
          notAnswered: this.reportData.generalDTO
            .porcentajeNoContestadasReflexionar,
        },
        {
          label: "Integrar e interpretar",
          correct: this.reportData.generalDTO.porcentajeCorrectasIntegrar,
          incorrect: this.reportData.generalDTO.porcentajeIncorrectasIntegrar,
          notAnswered: this.reportData.generalDTO
            .porcentajeNoContestadasIntegrar,
        },
      ];
    },
    toPDF() {
      const element = document.getElementById("main_" + this.courseId);
      const opt = {
        filename: `reporte_${this.reportData.courseTeacherDTO.course.ordinalGrade}_${this.reportData.courseTeacherDTO.course.section}_${this.dateFrom}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
        },
        margin: [0.3, 0.2, 0.2, 0.3],
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pageBreak: {
          mode: ["css", "legacy", "avoid-all"],
        },
      };

      // New Promise-based usage:
      const worker = html2pdf()
        .set(opt)
        .from(element)
        .save();

      worker
        .then(async () => {
          if (
            this.userData.pendingReportDTO.month !== this.reportPeriod.month ||
            this.userData.pendingReportDTO.year !== this.reportPeriod.year ||
            !this.userData.pendingReportDTO.pendingReports.some(
              coursePending => coursePending.id === this.courseId
            )
          )
            return;
          const response = await this.axios.post(
            this.dataUrl + `/monthlyReport/updateMonthlyReport`,
            {
              bookUserId: this.teacherId,
              coursesId: [this.courseId],
              month: this.reportPeriod.month,
            }
          );
          if (response.data) {
            this.removeCourse(this.reportData.courseTeacherDTO.course.id);
            this.removedFromSelectedCourses = true;
            this.removeCourseFromPending(
              this.reportData.courseTeacherDTO.course.id
            );
          }
        })
        .catch(error => {
          console.error("Error al guardar el reporte", error);
          this.$notify({
            title: [
              `No se pudo descargar reporte de curso ${this.courseName}, por falta de datos`,
            ],
            type: "danger",
          });
        })
        .finally(() => {
          this.addGenerateCourse({
            courseId: this.courseId,
            removedFromSelectedCourses: this.removedFromSelectedCourses,
          });
        });
    },
    async imageWithMetaData(metaData, url) {
      const imageBase64 = await this.dowloadImage(url);
      return {
        imageBase64,
        metaData,
      };
    },
    dowloadImage(imgModule) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/jpeg");
          resolve(dataURL);
        };
        img.onerror = error => {
          reject(error);
        };
        // eslint-disable-next-line no-undef
        img.src = imgModule;
      });
    },
  },
};
</script>
<style lang="scss">
.lightBorderReport {
  border: 2px solid LightGray;
}

.main-container {
  width: 100vw;
  height: 100vh;
  left: -100vw;
  top: 0;
  z-index: -9999;
  background: rgba(95, 95, 95, 0.8);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
  padding: 0px 0px 0px 5px;
}

#main {
  width: 100%;
  background: #fff;
}
.report-compresion {
  max-width: 50vh;
}
.text-small {
  font-size: 24px;
}

.text-content-card {
  font-size: 16px;
}
@media print, screen and (max-width: 64em) {
  .d-flex {
    display: flex !important;
  }
}

@media (max-width: 768px) {
  .stacked-bar-graph {
    width: 100%;
    height: 38px;
    color: #414042;

    span {
      box-sizing: border-box;
      float: left;
      font-weight: bold;
      font-family: arial, sans-serif;
      padding: 10px;
      border-radius: 20px;
      margin-right: -40px;
      color: rgba(0, 0, 0, 0);
    }

    .bar-1 {
      background: var(--color-secondary);
    }

    .bar-2 {
      background: var(--color-blue);
    }

    .bar-3 {
      background: var(--color-primary);
    }

    p {
      margin: auto; /* Important */
      text-align: center;
    }

    .circle {
      width: 65px;
      height: 65px;
      max-width: 65px;
      max-height: 65px;
      min-width: 65px;
      min-height: 65px;
      border-radius: 100px;
      display: flex;
      margin: 0 auto;
      margin-top: -22px;
    }
  }
}

#totalReadingChart {
  max-width: 340px;
  max-height: 340px;
  margin-top: -40px;
}

#totalBooksChart,
#totalChallengesChart,
#comprehensionChart {
  max-width: 280px;
  max-height: 280px;
  margin-top: -40px;
}

#evolutionChart {
  min-width: 700px;
  min-height: 400px;
}
</style>
